import { gql } from "@apollo/client";
import ThumbnailFragment from "./ThumbnailFragment";

export default gql`
  fragment ProcedureListingFragment on Procedure {
    uid
    title
    industry {
      slug
      label
    }
    topic {
      slug
      label
    }
    maintainer {
      id
      name
      thumbnail {
        ...ThumbnailFragment
      }
    }
    isFeatured
    listingDate
  }
  ${ThumbnailFragment}
`;
